// extracted by mini-css-extract-plugin
export default {"videoContainer":"Video_videoContainer__I+Fw4","videoFrame":"Video_videoFrame__ilEXj"};